import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString, turnEmptyArrayIntoNull } from '../../utils';
import { editProductsApi, fetchProductsApi, fetchProductVariantsApi } from '../../api/products-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  products: [],
  internalProducts: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchProductsListing = createAsyncThunk('products/listing', async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchProductsApi(paramsObj);
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const fetchInternalProducts = createAsyncThunk('internal-products/all', async (updatedParamsObject = {}) => {
  try {
    const updatedParamsObj = { 'f[product.type.slug][eq]': 'internal', per_page: 100, ...updatedParamsObject };
    const res = await fetchProductVariantsApi(updatedParamsObj);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

export const editProduct = createAsyncThunk(
  'products/edit',
  async ({ id, updatedParamsObject = {}, signal = null }) => {
    try {
      const paramsObj = {
        ...updatedParamsObject,
      };
      const res = await editProductsApi(id, paramsObj, signal);
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const ProductsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProductsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setProductsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchProductsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchProductsListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.products = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchProductsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      })
      .addCase(editProduct.fulfilled, (state, action) => {
        if (action?.payload?.data?.id) {
          const updatedProducts = state.products?.map((product) => {
            if (product?.id === action?.payload?.data?.id) {
              return action?.payload?.data;
            }
            return product;
          });

          state.products = [...updatedProducts];
        }
      })
      .addCase(fetchInternalProducts.fulfilled, (state, action) => {
        if (action?.payload?.data) state.internalProducts = turnEmptyArrayIntoNull(action?.payload?.data);
      });
  },
});

export const { setProductsActiveColumn, setProductsLoading } = ProductsSlice.actions;
export default ProductsSlice.reducer;
